<template>
<div class="text-xs-center">
    <v-dialog width="500" v-model="showDialog">
        <v-card>
            <v-card-title class="headline green" primary-title>
                <v-spacer></v-spacer>
                <v-btn icon dark mt-5 @click.prevent="update">
                    <v-icon>close</v-icon>
                </v-btn>
            </v-card-title>

            <v-card-text>
                <v-btn color="success">
                    <v-icon>fab fa-android</v-icon>
                </v-btn>

                <v-btn color="error">
                    <v-icon>fab fa-apple</v-icon>
                </v-btn>
            </v-card-text>

            <v-divider></v-divider>
        </v-card>
    </v-dialog>
</div>
</template>

<script>
export default {
    name: 'Dialog-Game',
    props: ["dialog"],
    data() {
        return {
            showDialog: this.dialog
        }
    },
    watch: {
        dialog(newValue) {
            return this.showDialog = newValue;
        }
    },
    methods: {
        update() {
            this.showDialog != this.showDialog;
            this.$emit('DialogChanged', this.showDialog);
        }
    }

}
</script>
